import { useState } from "react";
import SkillMatrixByUserService from "./SkillMatrixByUserService";
import debounce from "lodash/debounce";

const useSkillMatrixByUser = () => {
  const [searchText, setSearchText] = useState("");
  
  const [userOptions, setUserOptions] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [skills, setSkills] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchingUsers, setSearchingUsers] = useState(false);

  const fetchSkills = async (userId) => {
    try {
      setLoading(true);
      const res = await SkillMatrixByUserService.getSkillsByUser(userId);
      setSkills(res.data);
    } catch (err) {
      console.error("Failed to fetch skills:", err);
      setSkills([]);
    } finally {
      setLoading(false);
    }
  };

  const debouncedSearch = debounce(async (text) => {
    setSearchText(text);
    if (!text) {
      setUserOptions([]);
      return;
    }

    setSearchingUsers(true);
    try {
      const results = await SkillMatrixByUserService.searchUsersByName(text);
      const options = results.data.map((user) => ({
        label: `${user.firstName} ${user.lastName}`,
        value: user.id,
        fullUser: user,
      }));
      setUserOptions(options);
    } catch (error) {
      console.error("Error searching users:", error);
    } finally {
      setSearchingUsers(false);
    }
  }, 400);

  return {
    searchText,
    setSearchText,
    userOptions,
    searchingUsers,
    selectedUser,
    setSkills,
    setSelectedUser,
    skills,
    loading,
    fetchSkills,
    debouncedSearch,
  };
};

export default useSkillMatrixByUser;
